import { render } from "./BuildingQueueDetails.vue?vue&type=template&id=2a7ca6e2"
import script from "./BuildingQueueDetails.vue?vue&type=script&lang=js"
export * from "./BuildingQueueDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/partials/BuildingQueueDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a7ca6e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a7ca6e2', __exports__)) {
    api.reload('2a7ca6e2', __exports__)
  }
  
  module.hot.accept("./BuildingQueueDetails.vue?vue&type=template&id=2a7ca6e2", () => {
    api.rerender('2a7ca6e2', render)
  })

}


export default __exports__